<template>
  <div
    class="perk-container margin-bottom-xxs padding-xs"
  >
    <span
      :class="icon"
      class="icon margin-right-xxs"
    />
    <div class="perk">
      <slot />
    </div>
    <button
      class="tooltip icon"
      :class="isBcom ? 'tool-tip-dark-medium' : 'tooltip-large'"
      @click="emit('value-info-click', type)"
    />
  </div>
</template>
<script setup>
/* istanbul ignore file */
import { useBrand } from '@composables/useBrand';

defineProps({
  icon: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: '',
  },
});
const emit = defineEmits(['value-info-click']);
const { isBcom } = useBrand();
</script>

<style lang="scss" brand="mcom" scoped>
@import "@csgIcons/_financing.scss";
@import "@csgIcons/_registry-box.scss";
@import "@csgIcons/_personalized-offers.scss";
@import '@csgIcons/_tooltip-large.scss';

.perk-container {
  border-radius: rem-calc(5);
}
</style>

<style lang="scss" brand="bcom" scoped>
@import "@csgIcons/new/_gift-wrap-dark-medium.scss";
@import '@csgIcons/_loyallist-small.scss';
@import '@csgIcons/new/_financing-dark-medium.scss';
@import '@csgIcons/new/_personalized-offers-dark-medium.scss';
@import '@csgIcons/new/_tool-tip-dark-medium.scss';
</style>

<style lang="scss" scoped>
@import "~settingSCSS";

.perk-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  background-color: $background-color;
}
.special {
  background-color: #F6D96A;
}
.perk {
  overflow: hidden;
}
.icon {
  min-width: rem-calc(24);
  display: flex;
}
.tooltip {
  margin-left: auto;
  cursor: pointer;
  flex-shrink: 0;
}
</style>
